<template>
  <PanelPage ref="useAlerts" :loading-overlay="loadingOverlay">
    <v-card>
      <v-card-title>Get Managers from Park</v-card-title>
      <v-card-title>
        <v-autocomplete
          label="Park from which get the Managers"
          :items="parks"
          v-model="parkToQueryId"
          item-title="name"
          item-value="id"
        />
      </v-card-title>
      <template v-if="parkToQueryId">
        <v-divider/>
        <v-card-text>
          <v-container>
            <v-row>
              <template v-if="adminusers.length > 0">
                <v-col v-for="au in adminusers">
                  <v-card>
                    <v-card-title><b>Username:</b> {{ au['username'] }}</v-card-title>
                    <v-card-title><b>ID:</b> {{ au['id'] }}</v-card-title>
                  </v-card>
                </v-col>
              </template>
              <v-col v-else>
                <p class="text-center"><b>No Manager Found</b></p>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </template>
    </v-card>
  </PanelPage>
</template>

<script setup>
import PanelPage from "../components/PanelPage.vue";
import { ref, onMounted, watch } from "vue";
import { fetchParks, fetchParkAdmins } from "../remote/park.js";
import { objComparatorICase } from "../utils.js";

// State
const useAlerts = ref(null);
const loadingOverlay = ref(false);
const parks = ref([]);
const parkToQueryId = ref(null);
const adminusers = ref([]);

watch(parkToQueryId, async (newValue) => {
  if (newValue !== null) {
    loadingOverlay.value = true;
    try {
      const usersdata = await fetchParkAdmins(newValue);
      adminusers.value = usersdata.sort((a, b) => objComparatorICase(a, b, 'username'));
    } catch (e) {
      useAlerts.value.errorAlert('Error during Park Admins retrieve', e.toString());
    }
    loadingOverlay.value = false;
  }
});

// Hook
onMounted(async () => {
  loadingOverlay.value = true;
  try {
    // Retrieve Parks
    parks.value = await fetchParks();
  } catch (e) {
    useAlerts.value.errorAlert('Error during Park retrieve', e.toString());
  } finally {
    loadingOverlay.value = false;
  }
});
</script>

<style scoped>

</style>
